module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "chapter",
    attrs: {
      "epub:type": "dedication",
      "id": "ded",
      "role": "doc-dedication"
    }
  }, [_c('p', {
    staticClass: "dedf"
  }, [_c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": " Page v. ",
      "epub:type": "pagebreak",
      "id": "pv",
      "role": "doc-pagebreak"
    }
  }), _vm._v("To Sheu-Jane, always")]), _vm._v(" "), _c('p', {
    staticClass: "ded"
  }, [_vm._v("and")]), _vm._v(" "), _c('p', {
    staticClass: "ded"
  }, [_vm._v("To my newspaper friends down the years who helped see me through")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-53512136","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/wsu-gallagher-0007.vue
// module id = 72
// module chunks = 0